export class Constants {
    static SUGGESTED_ACTION_LOGIN = "LOGIN";
    static PROCESSING_TYPE_CODE = 'CODE';
    static PROCESSING_TYPE_LINK = 'LINK';
    static PROVIDER_SELF = "SELF";
    static AUTH_METHOD_EMAIL = "email";
    static AUTH_METHOD_PASSWORD = "password";
    static CONSENT_CLAIMS = "claim_consent"
    static CONSENT_SCOPES = "scope_consent"
    static FIELD_KEY = "fieldKey"
    static NAME = "name"
    static FIELD_NAME = "field_name"
    static ADDRESS = 'address'
}